import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { ExpandMore, ExpandLess } from '@mui/icons-material';
import { CalendarDateService } from '@uplift/services';
import { DateFormats } from '@uplift/constants';


const useStyles = makeStyles()(() => ({
  monthTitle: {
    fontWeight: 600,
    userSelect: 'none',
    whiteSpace: 'nowrap',
  },
  prevNextButton: {
    padding: 8,
  },
  prevNextButtonIcon: {
    fontSize: '12px',
  },
  expandButton: {
    padding: '4px',
    marginRight: '-26px',
  },
  expandButtonIcon: {
    fontSize: '18px',
  }
}));


export type MobileCalendarHeaderProps = {
  today: string;
  date: string;
  setDate: (m: string) => void;
  currentMonth: string;
  setCurrentMonth: (m: string) => void;

  leftAddons?: React.ComponentType<{ goToToday: () => void }>;
  rightAddons?: React.ComponentType<{ goToToday: () => void }>;

  expanded?: boolean;
  onMonthTitleClick?: () => void;
};


export const MobileCalendarHeader: React.FC<MobileCalendarHeaderProps> = ({ leftAddons: LeftAddons, rightAddons: RightAddons, ...props }) => {
  const { classes } = useStyles();
  const currentMonth = React.useMemo(() => CalendarDateService.date(props.currentMonth, DateFormats.ISO_DATE), [ props.currentMonth ]);
  const monthTitle = React.useMemo(() => {
    const date = CalendarDateService.date(props.date, DateFormats.ISO_DATE);
    const monthNumber = currentMonth.get('month');

    if (monthNumber === 0) {
      if (currentMonth.isSame(date, 'month')) {
        return currentMonth.format('MMMM D, YYYY');
      }

      return currentMonth.format('MMMM YYYY');
    }

    if (currentMonth.isSame(date, 'month')) {
      return date.format('MMMM D');
    }

    return currentMonth.format('MMMM');
  }, [ currentMonth, props.date ]);

  const goToToday = () => {
    props.setDate(props.today);
    props.setCurrentMonth(props.today);
  };

  return (
    <Box display="flex" flexDirection="column" width="100%">
      <Box display="flex" px={2} py="13px" pb={0} gap="8px">
        <Box display="flex" flex="1" alignItems="center">
          {LeftAddons && <LeftAddons goToToday={goToToday} />}
        </Box>
        <Box display="flex" flex="2" alignItems="center" justifyContent="center">
          <Box mr={1} />
          <Box display="flex" alignItems="center" onClick={props.onMonthTitleClick}>
            <Typography className={classes.monthTitle}>
              {monthTitle}
            </Typography>
            <IconButton size="small" className={classes.expandButton}>
              {props.expanded
                ? <ExpandLess className={classes.expandButtonIcon} />
                : <ExpandMore className={classes.expandButtonIcon} />
              }
            </IconButton>
          </Box>
          <Box ml={1} />
        </Box>
        <Box display="flex" flex="1" alignItems="center" justifyContent="flex-end">
          {RightAddons && <RightAddons goToToday={goToToday} />}
        </Box>
      </Box>
    </Box>
  );
};
